// components
import Video from '@components/Video';
// assets
import cover from '@assets/home/howToVideo.webp';

const Presentation = () => {
    return (
        <section>
            <div className="container">
                <h2 style={{
                    textAlign: 'center',
                    padding: '10px 0 50px 0',
                }}>
                    How To Video ?
                </h2>
                <Video cover={cover} id={'hf9KMiWitPA'} />
            </div>
        </section>
    )
}

export default Presentation